import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

/** Fade + rise on scroll into view. Pass mount to animate on mount instead. */
export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", mount = false }) => {
  const MotionTag = motion[as] || motion.div;
  const anim = mount
    ? { animate: { opacity: 1, y: 0 } }
    : { whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-80px" } };
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      {...anim}
      transition={{ duration: 0.7, delay, ease }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

/** Stagger container + item for grids. */
export const StaggerGroup = ({ children, className = "" }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.09 } } }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 28 }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.6, ease } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

/** Masked line reveal for hero headings. Pass an array of lines. */
export const MaskedLines = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: delay + i * 0.12, ease }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
